import { createAction } from 'redux-act';

export const updateSBAIsAuthenticatingState = createAction('sbaUser/AUTHENTICATING_STATE_UPDATE');
export const updateSBAAuthentication = createAction('sbaUser/AUTHENTICATION_UPDATE');
export const removeSBAAuthentication = createAction('sbaUser/AUTHENTICATION_REMOVE');
export const createSBAAuthentication = createAction('sbaUser/AUTHENTICATION_CREATE');
export const createSBAAuthenticationSuccess = createAction('sbaUser/AUTHENTICATION_SUCCESS');
export const createSBAAuthenticationFailure = createAction('sbaUser/AUTHENTICATION_FAILURE');
export const expireSBAAuthentication = createAction('sbaUser/TOKEN_EXPIRE');
